import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useV2CreateOpenRouterKeyMutation } from "@generated";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { handleAlert } from "@utils/helperFunctions";
import { AdminFormPage } from "@components/CatalogIndex";
import { OpenRouterKeyForm } from "../common/Form";
import { INITIAL_FORM_STATE, OpenRouterKeyFormState } from "../common/types";
import { formatOpenRouterKeyData } from "../common/helpers";
import "../style.css";

const FORM_ID = "open-router-key-form";

const New = (): JSX.Element => {
  const navigate = useNavigate();
  const [createOpenRouterKey] = useV2CreateOpenRouterKeyMutation();

  const [formState, setFormState] =
    useState<OpenRouterKeyFormState>(INITIAL_FORM_STATE);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showFailAlert, setShowFailAlert] = useState(false);

  const handleSave = () => {
    if (!formState.keyType) return;

    setLoading(true);
    const data = formatOpenRouterKeyData(formState);

    createOpenRouterKey({ body: { data } })
      .unwrap()
      .then((res) => {
        const id = res?.data?.id;
        if (id) {
          navigate(`/admin/open_router_keys/${id}/edit`);
        } else {
          setErrorMessage("Failed to create private LLM key.");
          setShowFailAlert(true);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setErrorMessage(
          error?.data?.errors?.[0]?.detail || "An error occurred."
        );
        setShowFailAlert(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {handleAlert(
        showFailAlert,
        errorMessage,
        setShowFailAlert,
        "warning",
        ToastAlert
      )}
      <AdminFormPage
        title="Add a Private LLM Key"
        formId={FORM_ID}
        onCancel={() => navigate("/admin/open_router_keys")}
        isSubmitting={loading}
      >
        <OpenRouterKeyForm
          formId={FORM_ID}
          formState={formState}
          setFormState={setFormState}
          editing={false}
          onSubmit={handleSave}
        />
      </AdminFormPage>
    </>
  );
};

export default New;
